import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  ResetView,
  SetCurrentView,
  SetView,
  ViewModel,
  ViewStateModel
} from './view.model';

@State<ViewStateModel>({
  name: 'view'
})
export class ViewState {
  @Selector()
  static view(state: ViewStateModel): ViewModel {
    return state[state.current];
  }

  @Selector()
  static state(state: ViewStateModel): ViewStateModel {
    return state;
  }

  constructor() {}

  @Action(SetCurrentView)
  setCurrentView(
    { patchState }: StateContext<ViewStateModel>,
    payload: SetCurrentView
  ) {
    return patchState({ current: payload.currentView });
  }

  @Action(SetView)
  setView(
    { patchState, getState }: StateContext<ViewStateModel>,
    { payload }: SetView
  ) {
    const state = getState();
    const viewSelection = payload.viewSelection;
    const oldViewState = state[viewSelection];
    let result: ViewModel;
    if (oldViewState)
      result = {
        ...oldViewState,
        ...{
          tabs: {
            ...oldViewState.tabs,
            ...payload.viewState.tabs
          },
          dateSelection: {
            ...oldViewState.dateSelection,
            ...payload.viewState.dateSelection
          },
          filterSelection: {
            ...oldViewState.filterSelection,
            ...payload.viewState.filterSelection
          }
        }
      };
    else result = payload.viewState;

    return patchState({ [viewSelection]: result });
  }

  @Action(ResetView)
  resetView({ setState }: StateContext<ViewStateModel>) {
    return setState({});
  }
}
